import { API } from "../../../cache";

async function apiJson(url, opts = {}) {
  const res = await fetch(url, { credentials: "include", ...opts });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const detail = data?.detail || data?.message || "Request failed";
    const err = new Error(detail);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

export function listTags({ moduleScope = "", search = "" } = {}) {
  const qs = new URLSearchParams();
  if (moduleScope) qs.set("module_scope", moduleScope);
  if (search) qs.set("search", search);
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiJson(`${API}/tags${suffix}`);
}

export function createTag(payload) {
  return apiJson(`${API}/tags`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function listTagMappings({ moduleName, entityId }) {
  const qs = new URLSearchParams({
    module_name: moduleName,
    entity_id: entityId,
  });
  return apiJson(`${API}/tags/mappings?${qs.toString()}`);
}

export function createTagMapping(payload) {
  return apiJson(`${API}/tags/mappings`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function deleteTagMapping(mappingId) {
  const res = await fetch(`${API}/tags/mappings/${mappingId}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) {
    let data = null;
    try {
      data = await res.json();
    } catch {
      data = null;
    }
    const detail = data?.detail || "Failed to delete tag mapping";
    const err = new Error(detail);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return true;
}
